// import React, { useEffect, useState } from "react";
// import NewDashboard from "./NewDashboard";
// import NewEditDashboard from "./NewEditDashboard";
// import NewAdminDashboard from "./NewAdminDashboard";

// const injectStyles = () => {
//   const id = "land-info-ui-styles";
//   if (document.getElementById(id)) return;
//   const css = `
//     :root {
//       --brand:#0e4a7b; /* sidebar */
//       --brand-dark:#0a3558;
//       --brand-accent:#2e7cc5; /* buttons */
//       --bg:#f5f7fb;
//       --card:#ffffff;
//       --text:#1e293b;
//       --muted:#6b7280;
//       --stroke:#e5e7eb;
//       --shadow:0 8px 24px rgba(16,24,40,.08);
//     }
//     *{box-sizing:border-box}
//     body { background: var(--bg); }

//     .app-wrap { min-height: 100vh; display:flex; }

//     /* Sidebar */
//     .side { width: 220px; background: var(--brand); color:#fff; display:flex; flex-direction:column; }
//     .side__logo { height: 64px;background: #fff;margin: 0 auto;width: 220px; }
//     .side__nav { padding: 12px 10px; flex:1; }
//     .nav__item { display:flex; align-items:center; gap:10px; padding:10px 12px; margin:6px 0; border-radius:10px; cursor:pointer; user-select:none; }
//     .nav__item:hover { background: rgba(255,255,255,.09); }
//     .nav__item svg { width:18px; height:18px; opacity:.95 }
//     .side__footer { padding: 16px 12px; border-top:1px solid rgba(255,255,255,.08); }
//     .btn-logout { width:100%; background:#fff; color:var(--brand); border:none; border-radius:10px; padding:10px 12px; font-weight:600; cursor:pointer; }

//     /* Main */
//     .main { flex:1; display:flex; flex-direction:column; }
//     .topbar { height:64px; background:#fff; border-bottom:1px solid var(--stroke); display:flex; align-items:center; justify-content:space-between; padding:0 20px; }
//     .crumbs { font-size:14px; color:var(--muted); }
//     .topbar__brand { display:flex; align-items:center; gap:10px; font-weight:600; color:var(--brand-dark); }
//     .avatar { width:28px; height:28px; border-radius:50%; background:linear-gradient(135deg,#ffc371,#ff5f6d); box-shadow:0 2px 6px rgba(0,0,0,.15) }

//     .content { padding: 24px; width:100%; display:flex; justify-content:center; }

//     /* Card */
//     .card { width:100%; max-width:1024px; background:var(--card); border:1px solid var(--stroke); border-radius:16px; box-shadow: var(--shadow); }
//     .card__head { padding: 18px 20px; border-bottom:1px solid var(--stroke); display:flex; align-items:center; justify-content:space-between; }
//     .card__title { font-size:16px; font-weight:700; color:var(--text); }

//     .form { padding: 20px; display:grid; grid-template-columns: repeat(4, minmax(0,1fr)); gap: 14px; }
//     .field { display:flex; flex-direction:column; gap:6px; }
//     .label { font-size:12px; color:var(--muted); font-weight:600; letter-spacing:.2px; }
//     .input, .select { height:38px; padding: 0 12px; border:1px solid var(--stroke); border-radius:10px; background:#fff; outline:none; transition:.15s border; }
//     .input:focus, .select:focus { border-color: var(--brand-accent); box-shadow: 0 0 0 3px rgba(46,124,197,.15) }
//     .select { appearance: none; background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="%236b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>'); background-repeat:no-repeat; background-position: right 10px center; background-size: 16px; padding-right:36px; }

//     .hero { display:flex; align-items:center; justify-content:center; padding: 8px 20px 0; }
//     .hero__box { width: 420px; height: 260px; border:1px dashed var(--stroke); border-radius:14px; display:flex; align-items:center; justify-content:center; flex-direction:column; gap:10px; background:linear-gradient(180deg,#f9fbff,#fff); }
//     .hero__note { font-size:12px; color:var(--muted); text-align:center; }

//     .cta { padding: 18px 20px 24px; display:flex; justify-content:center; }
//     .btn-primary { background: var(--brand-accent); color:#fff; border:none; border-radius:10px; padding: 12px 18px; font-weight:700; cursor:pointer; box-shadow: 0 6px 14px rgba(46,124,197,.28); }
//     .btn-primary:hover { filter: brightness(.98); }

//     /* Responsive */
//     @media (max-width: 1100px){ .form { grid-template-columns: repeat(2,minmax(0,1fr)); } }
//     @media (max-width: 640px){ .side{ display:none } .topbar{ padding:0 14px } .content{ padding:16px } .form{ grid-template-columns:1fr } }
//     .nav__item--active { background: rgba(255,255,255,.14); }

// .dash-grid {
//   padding: 20px;
//   display: grid;
//   grid-template-columns: repeat(4, minmax(0, 1fr));
//   gap: 14px;
// }
// .stat {
//   background: var(--bg);
//   border: 1px solid var(--stroke);
//   border-radius: 14px;
//   padding: 16px;
// }
// .stat__label { color: var(--muted); font-size: 12px; }
// .stat__value { font-weight: 800; font-size: 22px; color: var(--brand-dark); margin-top: 6px; }

// .table-view {
//   width: 100%;
//   border-collapse: separate;
//   border-spacing: 0;
//   border: 1px solid var(--stroke);
//   border-radius: 12px;
//   overflow: hidden;
//   background: #fff;
// }
// .table-view th, .table-view td {
//   padding: 10px 12px;
//   border-bottom: 1px solid var(--stroke);
//   text-align: left;
//   font-size: 14px;
// }
// .table-view thead th {
//   background: #f8fafc;
//   font-size: 12px;
//   color: var(--muted);
//   letter-spacing: .2px;
// }
// .table-view tbody tr:last-child td { border-bottom: none; }

// .padding-20 { padding: 20px; }

// @media (max-width: 1100px) { .dash-grid { grid-template-columns: repeat(2, minmax(0,1fr)); } }
// @media (max-width: 640px)  { .dash-grid { grid-template-columns: 1fr; } }
//   `;
//   const style = document.createElement("style");
//   style.id = id;
//   style.innerHTML = css;
//   document.head.appendChild(style);
// };

// const Icon = ({ path }) => (
//   <svg
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d={path} />
//   </svg>
// );

// const LandInfoAndCalculation = ({ handleLogout }) => {
//   useEffect(() => {
//     injectStyles();
//   }, []);

//   const [view, setView] = useState("dashboard");

//   const [isMobile, setIsMobile] = useState(false);

//   const checkMobileView = () => {
//     console.log("gggggggggggggggggggg ", window.innerWidth);
//     if (window.innerWidth <= 768) {
//       console.log("mame mobile da");
//       setIsMobile(true);
//     }
//   };

//   useEffect(() => {
//     checkMobileView();
//     window.addEventListener("resize", checkMobileView);

//     return () => {
//       window.removeEventListener("resize", checkMobileView);
//     };
//   }, []);

//   console.log("ffffffffffffffffffffffffff ", isMobile);

//   return (
//     <>
//       {/* desktopView */}
//       {isMobile === false && (
//         <div className="app-wrap">
//           {/* Sidebar */}
//           <aside className="side">
//             <div className="side__logo">
//               <img
//                 className="img-logo"
//                 src="/Casagrand-Logo1.webp"
//                 alt="logo"
//                 width={200}
//                 style={{ background: "white", margin: "8px 10px" }}
//               />
//             </div>
//             <nav className="side__nav">
//               <div
//                 className={`nav__item ${
//                   view === "adminDashboard" ? "nav__item--active" : ""
//                 }`}
//                 onClick={() => setView("adminDashboard")}
//               >
//                 <Icon path="M3 12l2-2 4 4 8-8 2 2-10 10-6-6" /> Admin Dashboard
//               </div>
//               <div
//                 className={`nav__item ${
//                   view === "dashboard" ? "nav__item--active" : ""
//                 }`}
//                 onClick={() => setView("dashboard")}
//               >
//                 <Icon path="M3 12l2-2 4 4 8-8 2 2-10 10-6-6" /> Dashboard
//               </div>
//               <div
//                 className={`nav__item ${
//                   view === "edit" ? "nav__item--active" : ""
//                 }`}
//                 onClick={() => setView("edit")}
//               >
//                 <Icon path="M3 12l2-2 4 4 8-8 2 2-10 10-6-6" /> Set New Land
//                 Params
//               </div>
//             </nav>
//             <div
//               className="side__footer"
//               style={{ position: "sticky", bottom: "0" }}
//             >
//               <button className="btn-logout" onClick={handleLogout}>
//                 Logout
//               </button>
//             </div>
//           </aside>

//           {/* Main */}
//           {view === "dashboard" && <NewDashboard handleLogout={handleLogout} />}
//           {view === "edit" && <NewEditDashboard handleLogout={handleLogout} />}
//           {view === "adminDashboard" && (
//             <NewAdminDashboard handleLogout={handleLogout} />
//           )}
//         </div>
//       )}
//     </>
//   );
// };

// export default LandInfoAndCalculation;

// import React, { useEffect, useState } from "react";
// import NewDashboard from "./NewDashboard";
// import NewEditDashboard from "./NewEditDashboard";
// import NewAdminDashboard from "./NewAdminDashboard";

// const injectStyles = () => {
//   const id = "land-info-ui-styles";
//   if (document.getElementById(id)) return;
//   const css = `
//     :root {
//       --brand:#0e4a7b;
//       --brand-dark:#0a3558;
//       --brand-accent:#2e7cc5;
//       --bg:#f5f7fb;
//       --card:#ffffff;
//       --text:#1e293b;
//       --muted:#6b7280;
//       --stroke:#e5e7eb;
//       --shadow:0 8px 24px rgba(16,24,40,.08);
//     }
//     *{box-sizing:border-box}
//     body { background: var(--bg); }

//     .app-wrap { min-height: 100vh; display:flex; }

//     /* Sidebar */
//     .side {
//       width: 220px; background: var(--brand); color:#fff;
//       display:flex; flex-direction:column;
//       transition: transform 0.3s ease;
//     }
//     .side__logo { height: 64px;background: #fff;margin: 0 auto;width: 220px; }
//     .side__nav { padding: 12px 10px; flex:1; }
//     .nav__item { display:flex; align-items:center; gap:10px; padding:10px 12px; margin:6px 0; border-radius:10px; cursor:pointer; user-select:none; }
//     .nav__item:hover { background: rgba(255,255,255,.09); }
//     .nav__item svg { width:18px; height:18px; opacity:.95 }
//     .nav__item--active { background: rgba(255,255,255,.14); }
//     .side__footer { padding: 16px 12px; border-top:1px solid rgba(255,255,255,.08); }
//     .btn-logout { width:100%; background:#fff; color:var(--brand); border:none; border-radius:10px; padding:10px 12px; font-weight:600; cursor:pointer; }

//     /* Mobile Sidebar (hidden by default) */
//     .side.mobile-hidden { transform: translateX(-100%); position: fixed; top:0; bottom:0; z-index: 999; }
//     .side.mobile-visible { transform: translateX(0); position: fixed; top:0; bottom:0; z-index: 999; }

//     /* Main */
//     .main { flex:1; display:flex; flex-direction:column; }
//     .topbar { height:64px; background:#fff; border-bottom:1px solid var(--stroke); display:flex; align-items:center; justify-content:space-between; padding:0 20px; }
//     .crumbs { font-size:14px; color:var(--muted); }
//     .topbar__brand { display:flex; align-items:center; gap:10px; font-weight:600; color:var(--brand-dark); }
//     .avatar { width:28px; height:28px; border-radius:50%; background:linear-gradient(135deg,#ffc371,#ff5f6d); box-shadow:0 2px 6px rgba(0,0,0,.15) }

//     .hamburger {
//       display: none;
//       font-size: 22px;
//       cursor: pointer;
//       color: var(--brand-dark);
//       background: none;
//       border: none;
//     }

//     /* Responsive */
//     @media (max-width: 768px) {
//       .side { transform: translateX(-100%); }
//       .hamburger { display: block; }
//       .app-wrap { flex-direction: column; }
//     }
//   `;
//   const style = document.createElement("style");
//   style.id = id;
//   style.innerHTML = css;
//   document.head.appendChild(style);
// };

// const Icon = ({ path }) => (
//   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
//     strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d={path} />
//   </svg>
// );

// const LandInfoAndCalculation = ({ handleLogout }) => {
//   useEffect(() => { injectStyles(); }, []);

//   const [view, setView] = useState("dashboard");
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   return (
//     <div className="app-wrap">
//       {/* Sidebar */}
//       <aside className={`side ${sidebarOpen ? "mobile-visible" : "mobile-hidden"}`}>
//         <div className="side__logo">
//           <img className="img-logo" src="/Casagrand-Logo1.webp" alt="logo" width={200}
//             style={{ background: "white", margin: "8px 10px" }}/>
//         </div>
//         <nav className="side__nav">
//           <div className={`nav__item ${view === "adminDashboard" ? "nav__item--active" : ""}`}
//             onClick={() => { setView("adminDashboard"); setSidebarOpen(false); }}>
//             <Icon path="M3 12l2-2 4 4 8-8 2 2-10 10-6-6" /> Admin Dashboard
//           </div>
//           <div className={`nav__item ${view === "dashboard" ? "nav__item--active" : ""}`}
//             onClick={() => { setView("dashboard"); setSidebarOpen(false); }}>
//             <Icon path="M3 12l2-2 4 4 8-8 2 2-10 10-6-6" /> Dashboard
//           </div>
//           <div className={`nav__item ${view === "edit" ? "nav__item--active" : ""}`}
//             onClick={() => { setView("edit"); setSidebarOpen(false); }}>
//             <Icon path="M3 12l2-2 4 4 8-8 2 2-10 10-6-6" /> Set New Land Params
//           </div>
//         </nav>
//         <div className="side__footer" style={{ position: "sticky", bottom: "0" }}>
//           <button className="btn-logout" onClick={handleLogout}>Logout</button>
//         </div>
//       </aside>

//       {/* Main */}
//       <div className="main">
//         <div className="topbar">
//           <button className="hamburger" onClick={() => setSidebarOpen(!sidebarOpen)}>☰</button>
//           <div className="topbar__brand"><span className="crumbs">Dashboard</span></div>
//           <div className="avatar" aria-label="User" />
//         </div>

//         {view === "dashboard" && <NewDashboard handleLogout={handleLogout} />}
//         {view === "edit" && <NewEditDashboard handleLogout={handleLogout} />}
//         {view === "adminDashboard" && <NewAdminDashboard handleLogout={handleLogout} />}
//       </div>
//     </div>
//   );
// };

// export default LandInfoAndCalculation;

import React, { useEffect, useMemo, useState } from "react";
import NewDashboard from "./NewDashboard";
import NewEditDashboard from "./NewEditDashboard";
import NewAdminDashboard from "./NewAdminDashboard";

/* ---------- styles injector (unchanged + a few mobile bits) ---------- */
const injectStyles = () => {
  const id = "land-info-ui-styles";
  if (document.getElementById(id)) return;
  const css = `
    :root {
      --brand:#0e4a7b; --brand-dark:#0a3558; --brand-accent:#2e7cc5;
      --bg:#f5f7fb; --card:#ffffff; --text:#1e293b; --muted:#6b7280;
      --stroke:#e5e7eb; --shadow:0 8px 24px rgba(16,24,40,.08);
    }
    *{box-sizing:border-box} body { background: var(--bg); }

    .app-wrap { min-height: 100vh; display:flex; }

    /* Sidebar (desktop) */
    .side { width: 220px; background: var(--brand); color:#fff; display:flex; flex-direction:column; }
    .side__logo { height: 64px; background:#fff; margin:0 auto; width:220px; }
    .side__nav { padding: 12px 10px; flex:1; }
    .nav__item { display:flex; align-items:center; gap:10px; padding:10px 12px; margin:6px 0; border-radius:10px; cursor:pointer; user-select:none; }
    .nav__item:hover { background: rgba(255,255,255,.09); }
    .nav__item svg { width:18px; height:18px; opacity:.95 }
    .nav__item--active { background: rgba(255,255,255,.14); }
    .side__footer { padding: 16px 12px; border-top:1px solid rgba(255,255,255,.08); }
    .btn-logout { width:100%; background:#fff; color:var(--brand); border:none; border-radius:10px; padding:10px 12px; font-weight:600; cursor:pointer; }

    /* Main */
    .main { flex:1; display:flex; flex-direction:column; }
    .topbar { height:64px; background:#fff; border-bottom:1px solid var(--stroke); display:flex; align-items:center; justify-content:space-between; padding:0 20px; }
    .crumbs { font-size:14px; color:var(--muted); }
    .topbar__brand { display:flex; align-items:center; gap:10px; font-weight:600; color:var(--brand-dark); }
    .avatar { width:28px; height:28px; border-radius:50%; background:linear-gradient(135deg,#ffc371,#ff5f6d); box-shadow:0 2px 6px rgba(0,0,0,.15) }
    .hamburger { display:none; font-size:22px; cursor:pointer; color:var(--brand-dark); background:none; border:none; }

    .content { padding:24px; width:100%; display:flex; justify-content:center; }

    /* Card, form, table, etc. (kept as you had) */
    .card { width:100%; max-width:1024px; background:var(--card); border:1px solid var(--stroke); border-radius:16px; box-shadow: var(--shadow); }
    .card__head { padding:18px 20px; border-bottom:1px solid var(--stroke); display:flex; align-items:center; justify-content:space-between; }
    .card__title { font-size:16px; font-weight:700; color:var(--text); }
    .form { padding:20px; display:grid; grid-template-columns: repeat(4, minmax(0,1fr)); gap:14px; }
    .field { display:flex; flex-direction:column; gap:6px; }
    .label { font-size:12px; color:var(--muted); font-weight:600; letter-spacing:.2px; }
    .input, .select { height:38px; padding: 0 12px; border:1px solid var(--stroke); border-radius:10px; background:#fff; outline:none; transition:.15s border; }
    .input:focus, .select:focus { border-color: var(--brand-accent); box-shadow:0 0 0 3px rgba(46,124,197,.15) }
    .select { appearance:none; background-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="%236b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>'); background-repeat:no-repeat; background-position:right 10px center; background-size:16px; padding-right:36px; }
    .hero { display:flex; align-items:center; justify-content:center; padding:8px 20px 0; }
    .hero__box { width:420px; height:260px; border:1px dashed var(--stroke); border-radius:14px; display:flex; align-items:center; justify-content:center; flex-direction:column; gap:10px; background:linear-gradient(180deg,#f9fbff,#fff); }
    .hero__note { font-size:12px; color:var(--muted); text-align:center; }
    .cta { padding:18px 20px 24px; display:flex; justify-content:center; }
    .btn-primary { background: var(--brand-accent); color:#fff; border:none; border-radius:10px; padding:12px 18px; font-weight:700; cursor:pointer; box-shadow:0 6px 14px rgba(46,124,197,.28); }
    .btn-primary:hover { filter:brightness(.98); }

    .dash-grid { padding:20px; display:grid; grid-template-columns: repeat(4, minmax(0,1fr)); gap:14px; }
    .stat { background:var(--bg); border:1px solid var(--stroke); border-radius:14px; padding:16px; }
    .stat__label { color:var(--muted); font-size:12px; }
    .stat__value { font-weight:800; font-size:22px; color:var(--brand-dark); margin-top:6px; }

    .table-view { width:100%; border-collapse:separate; border-spacing:0; border:1px solid var(--stroke); border-radius:12px; overflow:hidden; background:#fff; }
    .table-view th, .table-view td { padding:10px 12px; border-bottom:1px solid var(--stroke); text-align:left; font-size:14px; }
    .table-view thead th { background:#f8fafc; font-size:12px; color:var(--muted); letter-spacing:.2px; }
    .table-view tbody tr:last-child td { border-bottom:none; }
    .padding-20 { padding:20px; }

    @media (max-width:1100px){ .form{grid-template-columns:repeat(2,minmax(0,1fr));} .dash-grid{grid-template-columns:repeat(2,minmax(0,1fr));} }
    @media (max-width:640px){ .dash-grid{grid-template-columns:1fr;} }

    /* -------- Mobile drawer behavior -------- */
    @media (max-width: 768px) {
      .app-wrap { flex-direction: column; }
      .hamburger { display:block; }
      .side { position: fixed; top:0; bottom:0; left:0; z-index: 1000; transform: translateX(-100%); transition: transform .3s ease; }
      .side--open { transform: translateX(0); }
      .main { min-height: 100vh; }
      .topbar { padding: 0 14px; }
      .content { padding: 16px; }
      .form { grid-template-columns: 1fr; }
    }
  `;
  const style = document.createElement("style");
  style.id = id;
  style.innerHTML = css;
  document.head.appendChild(style);
};

/* ---------- tiny hook to know if we're mobile ---------- */
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= breakpoint
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return isMobile;
}

const Icon = ({ path }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d={path} />
  </svg>
);

const LandInfoAndCalculation = ({ handleLogout }) => {
  useEffect(() => {
    injectStyles();
  }, []);

  const [view, setView] = useState("dashboard");
  const isMobile = useIsMobile(768);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const userRole = localStorage.getItem("role") || "user";

  const NAV_ITEMS = [
    {
      key: "adminDashboard",
      label: "Admin Dashboard",
      iconPath: "M3 12l2-2 4 4 8-8 2 2-10 10-6-6",
      allowed: ["admin", "superuser"], // admins + superusers
    },
    {
      key: "dashboard",
      label: "Dashboard",
      iconPath: "M3 12l2-2 4 4 8-8 2 2-10 10-6-6",
      allowed: ["admin", "superuser", "user"], // everyone
    },
    {
      key: "edit",
      label: "Set New Land Params",
      iconPath: "M3 12l2-2 4 4 8-8 2 2-10 10-6-6",
      allowed: ["admin"], // only admins can edit config
    },
  ];

  const allowedItems = NAV_ITEMS.filter((i) => i.allowed.includes(userRole));

  useEffect(() => {
    if (!allowedItems.some((i) => i.key === view)) {
      setView(allowedItems[0]?.key || "dashboard");
    }
  }, [userRole]); // run when role changes

  const go = (next) => {
    // guard navigations
    if (allowedItems.some((i) => i.key === next)) setView(next);
  };

  // close drawer when route changes (mobile)
  useEffect(() => {
    if (isMobile) setDrawerOpen(false);
  }, [view, isMobile]);

  // Which page to show
  const Page = useMemo(() => {
    if (view === "edit")
      return <NewEditDashboard handleLogout={handleLogout} />;
    if (view === "adminDashboard")
      return <NewAdminDashboard handleLogout={handleLogout} />;
    return <NewDashboard handleLogout={handleLogout} />;
  }, [view, handleLogout]);

  return (
    <div className="app-wrap">
      {/* SIDEBAR */}
      {!isMobile ? (
        <aside className="side">
          <div className="side__logo">
            <img
              src="/Casagrand-Logo1.webp"
              alt="logo"
              width={200}
              style={{ background: "white", margin: "8px 10px" }}
            />
          </div>
          {/* <nav className="side__nav">
            <div
              className={`nav__item ${
                view === "adminDashboard" ? "nav__item--active" : ""
              }`}
              onClick={() => setView("adminDashboard")}
            >
              <Icon path="M3 12l2-2 4 4 8-8 2 2-10 10-6-6" /> Admin Dashboard
            </div>
            <div
              className={`nav__item ${
                view === "dashboard" ? "nav__item--active" : ""
              }`}
              onClick={() => setView("dashboard")}
            >
              <Icon path="M3 12l2-2 4 4 8-8 2 2-10 10-6-6" /> Dashboard
            </div>
            <div
              className={`nav__item ${
                view === "edit" ? "nav__item--active" : ""
              }`}
              onClick={() => setView("edit")}
            >
              <Icon path="M3 12l2-2 4 4 8-8 2 2-10 10-6-6" /> Set New Land
              Params
            </div>
          </nav> */}
          <nav className="side__nav">
            {allowedItems.map((item) => (
              <div
                key={item.key}
                className={`nav__item ${view === item.key ? "nav__item--active" : ""
                  }`}
                onClick={() => go(item.key)}
              >
                <Icon path={item.iconPath} /> {item.label}
              </div>
            ))}
          </nav>
          <div
            className="side__footer"
            style={{ position: "sticky", bottom: 0, display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <button className="btn-logout" onClick={handleLogout}>
              Logout
            </button>
            <div style={{ textAlign: "center" }}>
              <a href="/privacy-policy" style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.7rem", textDecoration: "none" }}>Privacy Policy</a>
            </div>
          </div>
        </aside>
      ) : (
        <>
          {/* Mobile topbar + hamburger */}
          <div className="topbar">
            <div className="topbar__brand">
              {/* <span className="crumbs">Dashboard123</span> */}
              <img
                src="/Casagrand-Logo1.webp"
                alt="logo"
                width={200}
                style={{ background: "white" }}
              />
            </div>
            {/* <div className="avatar" aria-label="User" /> */}
            <button
              className="hamburger"
              onClick={() =>
                setDrawerOpen((v) => {
                  const newState = !v;
                  console.log("Drawer toggled. Now open?", newState);
                  return newState;
                })
              }
            >
              ☰
            </button>
          </div>
          {/* Mobile drawer */}
          <aside className={`side ${drawerOpen ? "side--open" : ""}`}>
            <div className="side__logo">
              <img
                src="/Casagrand-Logo1.webp"
                alt="logo"
                width={200}
                style={{ background: "white", margin: "8px 10px" }}
              />
            </div>
            <nav className="side__nav">
              <div
                className={`nav__item ${view === "dashboard" ? "nav__item--active" : ""
                  }`}
                onClick={() => setView("dashboard")}
              >
                <Icon path="M3 12l2-2 4 4 8-8 2 2-10 10-6-6" /> Dashboard
              </div>
              {(userRole === "admin" || userRole === "superuser") && (
                <div
                  className={`nav__item ${view === "adminDashboard" ? "nav__item--active" : ""
                    }`}
                  onClick={() => setView("adminDashboard")}
                >
                  <Icon path="M3 12l2-2 4 4 8-8 2 2-10 10-6-6" /> Admin
                  Dashboard
                </div>
              )}
              {userRole === "admin" && (
                <div
                  className={`nav__item ${view === "edit" ? "nav__item--active" : ""
                    }`}
                  onClick={() => setView("edit")}
                >
                  <Icon path="M3 12l2-2 4 4 8-8 2 2-10 10-6-6" /> Set New Land
                  Params
                </div>
              )}
            </nav>
            <div
              className="side__footer"
              style={{ position: "sticky", bottom: 0, display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <button className="btn-logout" onClick={handleLogout}>
                Logout
              </button>
              <div style={{ textAlign: "center" }}>
                <a href="/privacy-policy" style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.7rem", textDecoration: "none" }}>Privacy Policy</a>
              </div>
            </div>
          </aside>
        </>
      )}

      {/* MAIN */}
      <div className="main">
        {/* {!isMobile && (
          <div className="topbar">
            <div className="topbar__brand"><span className="crumbs">Dashboard</span></div>
          </div>
        )} */}
        {Page}
      </div>
    </div>
  );
};

export default LandInfoAndCalculation;
